import React from 'react';

import {
  exportToCsv,
  tranformLineItemCellValue,
  makeFieldsNear,
} from '../../helpers/csv';
import { prettyKey } from '../../helpers/formatters';
import FormError from '../FormError';

class PurchaseCsvLineItemsButton extends React.Component {
  state = { loading: false, error: '' };

  getPlansByCarriers = (lineItems) => {
    let carrierPlans = {
      sprint: [],
      att: [],
      tracfone: [],
    };

    lineItems.forEach((item) => {
      if (item.sprint_plan && !carrierPlans.sprint.includes(item.sprint_plan)) {
        carrierPlans.sprint.push(item.sprint_plan);
      } else if (
        item.att_plan &&
        !carrierPlans.sprint.includes(item.att_plan)
      ) {
        carrierPlans.att.push(item.att_plan);
      } else if (
        item.tracfone_plan &&
        !carrierPlans.sprint.includes(item.tracfone_plan)
      ) {
        carrierPlans.tracfone.push(item.tracfone_plan);
      }
    });

    return carrierPlans;
  };

  getKeys = (purchase) => {
    const { line_items } = purchase;

    let keys = [];

    const nearFields = [
      ['id', 'carrier'],
      ['sprint_subscription', 'att_subscription', 'tracfone_subscription'],
      ['sprint_plan', 'att_plan', 'tracfone_plan'],
    ];

    for (let item of line_items) {
      for (let key in item) {
        if (!keys.includes(key)) {
          if (
            key.toLowerCase() !== 'options' &&
            !['sprint_plan', 'att_plan', 'tracfone_plan'].includes(
              key.toLowerCase(),
            )
          ) {
            keys.push(key);
          }
        }
      }
    }

    if (!keys.includes('carrier')) {
      keys.push('carrier');
    }

    keys = makeFieldsNear(keys, nearFields);

    return keys;
  };

  getCsv = async () => {
    const { purchase, fetchPurchaseWithAllLineItems } = this.props;
    let allLineItems;
    if (purchase.line_items.length <= purchase.line_items_count) {
      allLineItems = await fetchPurchaseWithAllLineItems(purchase.id, {});
    } else {
      allLineItems = purchase.line_items;
    }

    const purchaseWithAllLineItems = {
      ...purchase,
      line_items: allLineItems,
    };

    this.lineItemsToCsv(purchaseWithAllLineItems);
  };

  lineItemsToCsv = (purchase) => {
    const { line_items } = purchase;
    let content = '';

    const keys = this.getKeys(purchase);

    content += keys.map(prettyKey).join(',') + '\n';

    for (let item of line_items) {
      for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i];
        content += tranformLineItemCellValue(item, key) + ',';
      }
      const key = keys[keys.length - 1];
      content += tranformLineItemCellValue(item, key) + '\n';
    }

    exportToCsv(`purchase_${purchase.id}.csv`, content);
  };

  render() {
    const { loading, error } = this.state;
    return (
      <div>
        <button
          type="button"
          className="btn btn-primary mar-b"
          onClick={this.getCsv}
          disabled={loading}
        >
          {loading ? 'Generating csv...' : 'Download purchase items as csv'}
        </button>
        {error && <FormError error={error} />}
      </div>
    );
  }
}

export default PurchaseCsvLineItemsButton;
